/**
 * Post-sign-in redirect handling (AI-7825).
 *
 * `ProtectedRoute` stashes the attempted location in router state so sign-in
 * can return the user there (e.g. the "Start journaling" CTA on a blog post
 * pointing at /journal). Everything coming out of router state is treated as
 * untrusted input.
 */

/**
 * Only ever redirect to an internal, single-slash path. Absolute URLs,
 * protocol-relative `//evil.com`, and the auth pages themselves fall back to
 * the default destination.
 */
export function safeRedirectPath(from: unknown, fallback = "/chat"): string {
  if (typeof from !== "string") return fallback;
  if (!from.startsWith("/") || from.startsWith("//")) return fallback;
  if (from.startsWith("/sign-in") || from.startsWith("/sign-up")) return fallback;
  return from;
}
